import { useContext, useState } from 'react';
import { Container, Row, Col, Image, Nav, Button } from 'react-bootstrap';
import { ContactContext } from '../context/ContactContext';
import SocialIcons from '../components/SocialIcons';
import phoneIcon from '../assets/images/phone.svg';
import mailIcon from '../assets/images/mail.svg';
import '../assets/scss/sections/footer.scss';

function Footer() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const contact = useContext(ContactContext);
    const phoneNumbers = contact?.phone_number
        ? contact?.phone_number.replaceAll(' ', '').split(',')
        : [];
    const contactEmail = contact?.email;

    const handleSubmit = (e) => {
        e.preventDefault();

        // Check that email passed is valid
        if (!/\S+@\S+\.\S+/.test(email)) {
            setMessage("Please enter a valid email.");
            return;
        }

        // Simulate API call by logging email to console
        const success = true;

        if (success) {
            console.log(email); /* Send form data to API */
            setMessage("Thank you for subscribing!");
            setEmail(""); // Clear input field on success
        } else {
            setMessage("An error has occured. Please try again");
        }

    };

    return (
        <Container fluid as="footer" className="px-1 fs-6 mx-auto">
            {/* Newsletter section */}
            <Row as="section" id="newsletter" fluid className="py-5">
                <h2 className="py-2"><b>SUBSCRIBE TO</b> OUR NEWSLETTER</h2>
                <p>Get the latest updates about our latest development</p>
                <form className="py-0" onSubmit={ handleSubmit }>
                    <input
                        type="email"
                        name="email"
                        placeholder="max@gmail.com"
                        className="rounded text-center text-sm-start border-0 px-2 px-lg-3"
                        value={ email }
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                    />
                    <Button type="submit" className="px-3 px-lg-4">Subscribe Now</Button>
                    {message && <p className="form-message d-block">{message}</p>}
                </form>
            </Row>

            {/* Navigation section */}
            <Row as="section" id="navigation" xs={1} sm={1} md={1} lg={2} xl={4} className="border-bottom mx-3 mx-md-5 py-5 justify-content-between">
                {/* Company brief */}
                <Col className='my-3' lg={7} xl={3}>
                    <Image src="/logo240.png" href="/" className='pt-3' /><br />
                    {/* <h2 className='text-primary fw-bold'>AFINNEY REALTY</h2> */}
                    <p className="mt-3">REDEFINING PROPERTY ACQUISITION</p>
                </Col>

                {/* Useful links */}
                <Col className='my-3 col-auto' lg={5} xl={2}>
                    <h6 className="my-3">USEFUL LINKS</h6>
                    <Nav as="nav" id="footer-nav" className="flex-column">
                        <Nav.Link href="/properties" className="px-0">Properties</Nav.Link>
                        <Nav.Link href="/contact" className="px-0">Contact</Nav.Link>
                        <Nav.Link href="/inquiry" className="px-0">Inquiry Form</Nav.Link>
                    </Nav>
                </Col>

                {/* Contact */}
                <Col as="address" className='my-3' lg={7} xl={4}>
                    <h6 className="my-3">CONTACT</h6>
                    <Nav>
                        { (phoneNumbers && contactEmail) &&
                            <div id="nav-contact">
                                <Image src={ phoneIcon } width="20" height="19" className="d-inline me-3" />

                                {/* Phone numbers */}
                                {contact.phone_number.split(", ").map((number, index) => (
                                    <Nav.Link key={index} href={ `tel:${phoneNumbers[index]}` } className="px-0 d-inline">
                                        { number }
                                        { index < phoneNumbers.length - 1 && ", " }{/* Add comma if not the last element */}
                                    </Nav.Link>
                                ))}

                                {/* Email */}
                                <Nav.Link href={`mailto:${contactEmail}`} className="px-0 mt-2">
                                    <Image src={ mailIcon } width="20" height="19" className="me-3" />{ contactEmail }
                                </Nav.Link>
                            </div>
                        }
                    </Nav>
                </Col>

                {/* Connect */}
                <Col className='my-3 col-auto' lg={5} xl={2}>
                    <h6 className="my-3">CONNECT</h6>
                    <SocialIcons links={ contact && contact?.social_links } />
                </Col>
            </Row>

            {/* Copyright section */}
            <Row id="copyright" className="py-4 font-weight-bold">
                {/* <hr></hr> */}
                <p className="text-center">&#169; <small>2025 Afinney Realty Limited. All Rights Reserved</small></p>
            </Row>
        </Container>
    );
};

export default Footer;
